import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError, fmtDate } from "../lib/api";
import { PageHeader } from "./AdminLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function Audit() {
    const [logs, setLogs] = useState(null);
    const [filter, setFilter] = useState("");

    const load = () => api.get("/admin/audit", { params: filter ? { action: filter } : {} }).then((r) => setLogs(r.data)).catch((e) => toast.error(apiError(e)));
    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    return (
        <div data-testid="admin-audit">
            <PageHeader title="Journal d'audit" subtitle="Connexions, changements de rôles, publications, suppressions, prix et liens stores — chaque action sensible est tracée." />
            <div className="flex gap-3 mb-5">
                <Input placeholder="Filtrer par action (ex : user., media., offer.)…" value={filter} onChange={(e) => setFilter(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} className="max-w-sm bg-white" data-testid="audit-filter-input" />
                <Button variant="outline" onClick={load} data-testid="audit-filter-button">Filtrer</Button>
            </div>
            <div className="rounded-2xl bg-white border border-gold/25 shadow-sm overflow-x-auto">
                <table className="w-full text-sm" data-testid="audit-table">
                    <thead>
                        <tr className="text-left text-xs uppercase tracking-wider text-pineneedle border-b">
                            <th className="p-4">Date</th><th className="p-4">Acteur</th><th className="p-4">Action</th><th className="p-4">Cible</th><th className="p-4">Détail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(logs || []).map((l, i) => (
                            <tr key={i} className="border-b last:border-0">
                                <td className="p-4 text-xs text-pineneedle whitespace-nowrap">{fmtDate(l.created_at)}</td>
                                <td className="p-4 text-xs">{l.actor_email || "—"}</td>
                                <td className="p-4"><span className="font-mono text-xs bg-cream-subtle px-2 py-1 rounded">{l.action}</span></td>
                                <td className="p-4 text-xs">{l.target}</td>
                                <td className="p-4 text-xs text-pineneedle max-w-xs truncate">{l.detail}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {logs && logs.length === 0 && <p className="p-8 text-center text-pineneedle text-sm">Aucun événement enregistré.</p>}
            </div>
        </div>
    );
}
